import {Module} from "vuex";
import {IDBase, QueryFacade} from "@/controller/QueryFacade";
import {HasRightResponse} from "@/store/CurrencyStore";
import {AsyncJavaRequest, Main} from "@/controller/main";

class FileField {
    public label: string = "";
    public file: string = "";
}

class HeadFileField extends FileField{
    public fileId:string="";
}

export class ExportConfigHead implements IDBase {
    public id: string = "";
    public labels: HeadFileField[] = [];
}
class ExportConfigFile implements IDBase {
    public id: string = "";
    public data: string[] = [];
}

export class ExportConfigState {
    public singlePpanelFiles: FileField[] = [];
    public fullPpanelFiles: FileField[] = [];
}

class RightToCreate {
    public tag:string="";
    public name:string="";
    public label:string="";


    constructor(tag: string, name: string, label: string) {
        this.tag = tag;
        this.name = name;
        this.label = label;
    }
}
export class CreateRightsRequest {
    public rightsToCreate: RightToCreate[] = [];
}

export class ImportConfigStore implements Module<any, unknown> {
    public namespaced = true;
    public state: ExportConfigState = new ExportConfigState();

    public getters: { [func: string]: () => any } = {};

    public mutations = {
        addSinglePPanelFIle(state: ExportConfigState) {
            state.singlePpanelFiles.push(new FileField());
        },
        addGlobalPPanelFIle(state: ExportConfigState) {
            state.fullPpanelFiles.push(new FileField());
        },
        persist: function (state: ExportConfigState) {
            const heads: ExportConfigHead[] = [];
            const files: ExportConfigFile[] = [];
            for (let key of Object.keys(state)) {
                const labels: HeadFileField[] = [];
                for (let idx = 0; idx < (<any>state)[key].length; idx++) {
                    const aFileField = (<any>state)[key][idx];
                    const fileId = key + "_" + idx;
                    labels.push(
                        {
                            file: "",
                            label: aFileField.label,
                            fileId:fileId
                        }
                    );

                    if (aFileField.file) {

                        files.push({
                            id: fileId,
                            data: aFileField.file
                        });
                    }
                }

                heads.push({
                    id: key,
                    labels: labels
                });


            }
            const request = new CreateRightsRequest();

            for (let i = 0; i < heads.length; i++){
                let aHead = heads[i];
                QueryFacade.put("export_config", aHead);
                for (let idx = 0; idx < aHead.labels.length; idx++){
                    let label = aHead.labels[idx];
                    request.rightsToCreate.push(new RightToCreate(
                        aHead.id+"_ExportConfigButton_"+idx,
                        aHead.id+"_ExportConfigButton_"+idx,
                       "Can use Export button '"+label.label+"'"
                    ));
                }

            }

            for (let file of files) {
                QueryFacade.put("export_config_files", file);
            }


            Main.postMessage(
                new AsyncJavaRequest("call", "createRights", JSON.stringify(request))
            ).then(()=>{
                console.log("Rights Created");
            }).catch((e)=>{
                console.error("Error during right creation",e);
            });
        },

        async loadFromDb(state: ExportConfigState) {
            const orgstate = new ExportConfigState();
            for (let key of Object.keys(orgstate)) {
                const res = await loadExportConfig(key);
                (<any>exportConfigStore).state[key] = (<any>orgstate)[key];
                if (res) {
                    (<any>exportConfigStore).state[res.id] = res.labels;
                }
            }
        }
    };


    constructor() {
        for (let key of Object.keys(this.state)) {
            this.getters[key] = () => {
                return (<any>this.state)[key];
            }
        }
    }
}

export const exportConfigStore = new ImportConfigStore();

export async function loadExportConfig(id:string):Promise<ExportConfigHead>{
    return QueryFacade.get("export_config", id);
}